var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"spinner-change",attrs:{"data-test":"spinner"}},_vm._l((12),function(index){return _c('div',{key:index,class:_vm.color})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }